import { Columns, breakpoints, Column } from '@etg/wings';
import type { BestPricesPerPeriod } from '@eti/schema-types';
import { useMediaQuery } from 'usehooks-ts';
import PopularRoutesCarousel from '../popular-routes/PopularRoutesCarousel';
import type { Location } from './models';
import PriceListCard from './PriceListCard';

interface PriceListProps {
  tripType: string;
  origin: Location;
  destination: Location;
  flights: BestPricesPerPeriod['bestPricesPerPeriod'];
}

const PriceList = ({ tripType, origin, destination, flights }: PriceListProps) => {
  const isNarrowViewport = useMediaQuery(`(max-width: ${breakpoints._560})`);

  return isNarrowViewport ? (
    <PopularRoutesCarousel data-testid="carousel">
      {flights.map((flight) => (
        <PriceListCard
          destination={destination}
          flight={flight}
          key={`${tripType}-PriceListCarousel`}
          origin={origin}
          tripType={tripType}
        />
      ))}
    </PopularRoutesCarousel>
  ) : (
    <Columns data-testid="price-lists-columns" spacing={16}>
      {flights.map((flight) => (
        <Column
          data-testid="price-list-column"
          key={`${tripType}-price-list-column-${flight.period}`}
          width="2/6"
        >
          <PriceListCard
            destination={destination}
            flight={flight}
            key={`${tripType}-PriceListCard`}
            origin={origin}
            tripType={tripType}
          />
        </Column>
      ))}
    </Columns>
  );
};

export default PriceList;
